export default {
  updateModels(state, data) {
    if (data.length < 1) {
      state.models = null;
    } else {
      state.models = data;
    }
  },

  updateCameraPhoto(state, value = null) {
    state.cameraPhoto = value;
  },

  updateIsTriggerModelPopover(state, value = false) {
    state.isTriggerModelPopover = value;
  },

  updatePreselectedModel(state, value = null) {
    state.preselectedModel = value;
  },

  updatePreselectedSystem(state, value = null) {
    state.preselectedSystem = value;
  },

  updateMaterialsItem(state, val = null) {
    state.materialsItem = val;
  },

  updateIsDisabledMaterials(state, val = true) {
    state.isDisabledMaterials = val;
  },

  updateIsDisabledSizes(state, val = true) {
    state.isDisabledSizes = val;
  },

  updateIsDisabledOptions(state, val = true) {
    state.isDisabledOptions = val;
  },

  resetAllAccordion(state) {
    state.isDisabledMaterials = true;
    state.isDisabledSizes = true;
    state.isDisabledOptions = true;
    state.triggerResetData += 1;
  },

  // TODO: в идеале уйти к updateSystemItem
  updateSystem(state, val = null) {
    state.system = val;

    if (typeof val === 'number') {
      state.preselectedSystem = state.models[val];
    } else {
      state.preselectedSystem = null;
    }
  },

  updateSystemItem(state, systemItem = null) {
    const findIndex = state.models.findIndex(el => el.id === systemItem?.id);

    state.system = findIndex > -1 ? findIndex : null;
  },

  updateModel(state, val = null) {
    state.model = val;
  },

  updateSubModel(state, val) {
    state.subModel = val;
  },

  updateMaterials(state, data) {
    state.materials = data;
    for (let i = 0; i < state.materials.length; i++) {
      if (
        state.materials[i].material.material_collection.composition !== null &&
        state.materials[i].material.material_collection.composition !== ''
      ) {
        state.materials[i].material.material_collection.composition = state.materials[
          i
        ].material.material_collection.composition.replace(/[^a-zA-Z]/gi, '');
      }
    }
  },

  updateModelSizeHeight(state, val) {
    state.modelSize.height = val;
  },

  updateModelSizeWidth(state, val) {
    state.modelSize.width = val;
  },

  resetModelSize(state) {
    state.modelSize.width = '';
    state.modelSize.height = '';
  },

  resetSystemAndModel(state) {
    state.system = null;
    state.model = null;
    state.subModel = null;
  },

  updateQueryParamsElement(state, val) {
    if (val.includes('l')) {
      state.queryParams.element.logo = false;
    }
    if (val.includes('b')) {
      state.queryParams.element.basket = false;
    }
    if (val.includes('c')) {
      state.queryParams.element.sum = false;
    }
    if (val.includes('t')) {
      state.queryParams.element.header = false;
    }
    if (val.includes('p')) {
      state.queryParams.element.price = false;
    }
  },

  updateQueryParamsSize(state, { width = '', height = '' }) {
    state.queryParams.size.width = width
    state.queryParams.size.height = height
  },

  updateQueryParamsSystem(state, val) {
    state.queryParams.model.type = val;
  },

  updateQueryParamsSub(state, val) {
    state.queryParams.model.sub = val;
  },

  updateQueryParamsModel(state, val) {
    state.queryParams.model.model = val;
  },

  updateQueryParamsMaterial(state, val) {
    state.queryParams.model.material = val;
  },
};
